// @ts-strict-ignore
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { subscriptionGroupsKey } from "./constants";
import type { InternalSubscriptionGroupPayload } from "./types";

export const getSubscriptionGroups = reactQueryFetcherAdapter(
  subscriptionGroupsKey,
  async (signal, appGroupId: string, limit?: number): Promise<InternalSubscriptionGroupPayload> => {
    return fetch(
      `/engagement/${appGroupId}/email_subscription_groups`,
      "GET",
      { query: null, limit },
      {
        signal,
      }
    );
  }
);
